import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Testimonials = () => {
  const testimonials = [
    {
      img: "assets/img/testimonials/testimonials-1.jpg",
      name: "Saul Goodman",
      role: "Ceo & Founder",
      review:
        "Working with this team has been a game-changer for my business. Their solutions are tailored to meet our specific needs, and the results speak for themselves. I couldn't be happier!",
    },
    {
      img: "assets/img/testimonials/testimonials-2.jpg",
      name: "Sara Wilsson",
      role: "Designer",
      review:
        "The creative input from this team has exceeded our expectations. Their attention to detail and dedication to bringing our vision to life has been fantastic. Highly recommended!",
    },
    {
      img: "assets/img/testimonials/testimonials-3.jpg",
      name: "Jena Karlis",
      role: "Store Owner",
      review:
        "Our store's growth has been incredible thanks to the professional advice and support we received. The team's expertise in e-commerce helped us streamline our processes and expand our reach.",
    },
    {
      img: "assets/img/testimonials/testimonials-4.jpg",
      name: "Matt Brandon",
      role: "Freelancer",
      review:
        "I've worked with many agencies, but none have provided the level of service and results that this team has. They truly care about their clients' success and deliver outstanding work every time!",
    },
    {
      img: "assets/img/testimonials/testimonials-5.jpg",
      name: "John Larson",
      role: "Entrepreneur",
      review:
        "This team has helped me build my brand from the ground up. Their creative ideas and professional approach have made all the difference in my business's success. I can't thank them enough!",
    },
  ];

  return (
    <section id="testimonials" className="testimonials section light-background">
      <div className="container section-title">
        <h2>Testimonials</h2>
        <p>
          Our clients share their experiences and the success they've achieved
          using our services.
        </p>
      </div>

      <div className="container">
        <Swiper
          modules={[Pagination, Autoplay]}
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          pagination={{ clickable: true }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-item">
                <img
                  src={testimonial.img}
                  className="testimonial-img"
                  alt={testimonial.name}
                />
                <h3>{testimonial.name}</h3>
                <h4>{testimonial.role}</h4>
                <div className="stars">
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left"></i>
                  <span>{testimonial.review}</span>
                  <i className="bi bi-quote quote-icon-right"></i>
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-pagination"></div>
      </div>
    </section>
  );
};

export default Testimonials;
